export default process.env.NODE_ENV != "production" ? {
  node_api_endpoint: 'http://localhost:4004/v1',
  // node_api_endpoint: 'https://pgportalapi.escrowstack.io/v1',
  // node_api_endpoint: 'https://simportalapi.myground11.co.in/v1',
  firebaseConfig: {
    apiKey: "AIzaSyAkhiKqmu5P6eKYQRWL7BfsebKPXc5ZoGo",
    authDomain: "espayout-13384.firebaseapp.com",
    projectId: "espayout-13384",
    storageBucket: "espayout-13384.firebasestorage.app",
    messagingSenderId: "88320446058",
    appId: "1:88320446058:web:8bf111bc50fd050e790413",
    measurementId: "G-4V3CBD7Q3D"
  }
} : {
  node_api_endpoint: 'https://portalapiesdf.escrowstack.io/v1',
  //'https://portalindapi.escrowstack.io/v1',
  // node_api_endpoint: 'https://pgportalapi.escrowstack.io/v1/',
  // node_api_endpoint: 'https://portalnsdl.escrowstack.io/v1',
  // node_api_endpoint: 'https://simportalapi.myground11.co.in/v1',
  node_api_admin_endpoint: `http://localhost:3002`,
  firebaseConfig: {
    apiKey: "AIzaSyAkhiKqmu5P6eKYQRWL7BfsebKPXc5ZoGo",
    authDomain: "espayout-13384.firebaseapp.com",
    projectId: "espayout-13384",
    storageBucket: "espayout-13384.firebasestorage.app",
    messagingSenderId: "88320446058",
    appId: "1:88320446058:web:8bf111bc50fd050e790413",
    measurementId: "G-4V3CBD7Q3D"
  }
}